import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { Button } from '@arkestro/arkestro-design-system';
import useTranslation from 'next-translate/useTranslation';

import { UserContext } from '@providers/UserProvider/UserProvider';
import FloatingPanel from '@components/on_board/FloatingPanel/FloatingPanel';
import Footer from '@components/on_board/Footer/Footer';
import ProfileFields from '@components/shared/EditProfile/ProfileFields';

import style from './VendorProfileFields.module.scss';

const VendorProfileFields = ({ currentStepName, updateOnboardStep, progress, setProperty, userParams }) => {
  const { t } = useTranslation('common');
  const currentUser = useContext(UserContext);

  const [firstName, setFirstName] = useState(userParams.firstName);
  const [lastName, setLastName] = useState(userParams.lastName);
  const [jobTitle, setJobTitle] = useState(userParams.jobTitle);

  const handleChange = event => {
    let setFn;

    switch (event.target.name) {
      case 'lastName':
        setFn = setLastName; break;
      case 'jobTitle':
        setFn = setJobTitle; break;
      default:
        setFn = setFirstName; break;
    }

    setFn(event.target.value);
  };

  const handleSubmit = event => {
    event.preventDefault();

    setProperty({ userParams: { ...userParams, firstName, lastName, jobTitle } });
    updateOnboardStep(currentStepName); // updates onboarding state, which advances to next step
  };

  const readOnlyEditingFields = [
    [
      { key: 'email', label: 'email', value: currentUser.email, required: false, errors: [] }
    ]
  ];

  const normalFields = [
    [
      { key: 'firstName', label: t('general.first_name'), value: firstName, required: true, errors: [] },
      { key: 'lastName', label: t('general.last_name'), value: lastName, required: true, errors: [] },
    ],
    [
      { key: 'jobTitle', label: t('general.job_title'), value: jobTitle, required: true, errors: [] }
    ]
  ];

  return (
    <FloatingPanel colSizes={{ xs: 24, sm: 16, md: 14, lg: 12, xl: 8 }}>
      <div className={style.titleContainer}>
        <h4 className={style.title}>
          {t('onboarding.buyer.welcome_title')}
        </h4>
        <div className={style.secondTitle}>
          {t('onboarding.buyer.welcome_subtitle')}
        </div>
      </div>

      <p className={style.email}>
        {currentUser.email}
      </p>

      <form onSubmit={handleSubmit}>
        <ProfileFields
          normalFields={normalFields}
          onChange={handleChange}
          readOnlyEditingFields={readOnlyEditingFields}
        />
        <div className={style.buttons}>
          <Button
            disabled={progress}
            htmlType='submit'
            loading={progress}
            type="primary"
          >
            {t('general.continue')}
          </Button>
        </div>
      </form>
      <Footer />
    </FloatingPanel>
  );
};

VendorProfileFields.propTypes = {
  currentStepName: PropTypes.string.isRequired,
  progress: PropTypes.bool.isRequired,
  setProperty: PropTypes.func.isRequired,
  updateOnboardStep: PropTypes.func.isRequired,
  userParams: PropTypes.shape({
    firstName: PropTypes.string,
    jobTitle: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired
};

export default VendorProfileFields;
